export const CURRENCY_DEFINITIONS = "/Currency/GetCurrencyDef"
export const CURRENCY_INSERT = "/Currency/InsertCurrencyDef"
export const CURRENCY_UPDATE = "/Currency/UpdateCurrencyDef"
export const CURRENCY_DELETE = "/Currency/DeleteCurrencyDef"